import { Alert, Box, Paper, useTheme } from "@mui/material";
import * as React from "react";
import { Link } from "react-router-dom";

import { PageBreadcrumbs, PageLayout } from "@/shared/components";
import { CreateDatasetForm } from "@/shared/components/CreateDatasetForm";

export function CreateDataset() {
  const theme = useTheme();

  const [errorText, setErrorText] = React.useState<string>("");

  return (
    <PageLayout
      title={"Roboto - Create Dataset"}
      headerContentLeft={
        <PageBreadcrumbs>
          <Link to="/datasets">Datasets</Link>
          <span>Create Dataset</span>
        </PageBreadcrumbs>
      }
    >
      <Box>
        <Box
          sx={{
            mb: theme.spacing(2),
          }}
        >
          {errorText ? (
            <Alert severity="error">{errorText}</Alert>
          ) : (
            <Alert severity="info">
              Complete the form below to create a new dataset.
            </Alert>
          )}
        </Box>
        <Box
          component={Paper}
          variant="outlined"
          sx={{ p: theme.spacing(1.5), background: "none" }}
        >
          <Box
            sx={{
              maxWidth: "60ch",
            }}
          >
            <CreateDatasetForm setErrorText={setErrorText} />
          </Box>
        </Box>
      </Box>
    </PageLayout>
  );
}
